export const DELETE_PAGE_LINK = 'action-remove-content-link';
export const ACTION_MOVE_BLOG_DIALOG = 'action-move-blogpost-dialog-link';
export const REVERT_EDITOR_LINK = 'action-downgrade-to-tiny';
export const ACTION_COPY_PAGE = 'action-copy-page-link';
export const ACTION_MOVE_PAGE = 'action-move-page-dialog-link';
export const ACTION_ARCHIVE_PAGE = 'action-archive-link';
export const ACTION_EDIT_EMBED = 'action-edit-embed-modal';
export const PAGE_HISTORY_LINK = 'action-view-history-link';
export const ACTION_MENU_RESOLVED_INLINE_COMMENTS = 'bm-resolved-inline-comments';
